import { render, staticRenderFns } from "./DriverInfo.vue?vue&type=template&id=5dd2e8ee"
import script from "./DriverInfo.vue?vue&type=script&lang=js"
export * from "./DriverInfo.vue?vue&type=script&lang=js"
import style0 from "./DriverInfo.vue?vue&type=style&index=0&id=5dd2e8ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports